import './style.css'
import { Canvas } from '@react-three/fiber'
import Experience from './Experience.jsx'
import { KeyboardControls, Loader } from '@react-three/drei'
import { Suspense, useState } from 'react';
import Interface from './Interface.jsx'
import ambience from "../public/sound/ambient-background.mp3"


function App() {
    const [start, setStart] = useState(false);


    return (
        <>
            <KeyboardControls
                map={[
                    { name: 'forward', keys: ['ArrowUp', 'KeyW'] },
                    { name: 'backward', keys: ['ArrowDown', 'KeyS'] },
                    { name: 'leftward', keys: ['ArrowLeft', 'KeyA'] },
                    { name: 'rightward', keys: ['ArrowRight', 'KeyD'] }
                ]}>

                <Canvas
                    shadows
                    camera={{
                        fov: 55,
                        near: 0.1,
                        far: 100,
                        position: [0, 2, 7]
                    }}
                > <Suspense fallback={null}>
                        <Experience />
                    </Suspense>
                </Canvas>
                <Loader 
                />
                <Interface />
            </KeyboardControls>
            
        </>
    )
}

export default App;
